import type { MedicalSupplyHomeIdType } from '@app/icare/entities/medicalSupplyHome/schema/MedicalSupplyHome'
import { ContactPersonTable } from '@app/icare/routes/_app/apotheken/-components/ContactPersonTable'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/sanitaetshaeuser/$id/contact-persons')({
  component: RouteComponent,
})

function RouteComponent() {
  return <ContactPersonTable ownerId={Route.useParams().id as MedicalSupplyHomeIdType} />
}
